import React from 'react';

export default function RankingFactorsChart({ data }) {
  if (!data || !data.rankingFactors) {
    return <div className="ranking-factors"><p>No ranking factors available</p></div>;
  }

  const rf = data.rankingFactors;

  return (
    <div className="ranking-factors">
      <h3>📈 YouTube Ranking Factors</h3>
      <div className="factors-grid">
        {/* Metadata Optimization */}
        <div className="factor-category">
          <h4>🏷️ Metadata Optimization</h4>
          <div className="factor-item">
            <span>Title Score: </span>
            <span className="score">{rf.metadataOptimization?.titleScore || 0}/100</span>
          </div>
          <div className="factor-item">
            <span>Description Score: </span>
            <span className="score">{rf.metadataOptimization?.descriptionScore || 0}/100</span>
          </div>
          <div className="factor-item">
            <span>Tag Effectiveness: </span>
            <span className="score">{rf.metadataOptimization?.tagEffectiveness || 0}/100</span>
          </div>
        </div>

        {/* Engagement Signals */}
        <div className="factor-category">
          <h4>💬 Engagement Signals</h4>
          <div className="factor-item">
            <span>CTR: </span>
            <span>{rf.engagementSignals?.ctr || 'N/A'}</span>
          </div>
          <div className="factor-item">
            <span>Watch Time: </span>
            <span>{rf.engagementSignals?.watchTime || 'N/A'}</span>
          </div>
          <div className="factor-item">
            <span>Like Ratio: </span>
            <span>{rf.engagementSignals?.likeRatio || 'N/A'}</span>
          </div>
          <div className="factor-item">
            <span>Comments: </span>
            <span>{rf.engagementSignals?.commentEngagement || 'N/A'}</span>
          </div>
        </div>

        {/* Content Performance */}
        <div className="factor-category">
          <h4>⚡ Content Performance</h4>
          <div className="factor-item">
            <span>Length Optimization: </span>
            <span className="score">{rf.contentPerformance?.lengthOptimization || 0}/100</span>
          </div>
          <div className="factor-item">
            <span>Freshness Score: </span>
            <span className="score">{rf.contentPerformance?.freshnessScore || 0}/100</span>
          </div>
          <div className="factor-item">
            <span>Topic Relevance: </span>
            <span className="score">{rf.contentPerformance?.topicRelevance || 0}/100</span>
          </div>
        </div>
      </div>
    </div>
  );
}
